import { Email } from '@carbon/icons-react';
import { PayPal } from '@routable/icons';
import React from 'react';
import { getFundingInfoAddressDisplayName, isFundingAccountBankAccount, isFundingAccountPayPalDirect, } from 'helpers/funding';
import { AccountAddress } from 'modules/fundingAccount/bankAccount/components';
const PaymentMethodHintBaseContent = ({ fundingAccount, fundingInfoAddress, fundingInfoPaypal, }) => {
    const isBankAccount = isFundingAccountBankAccount(fundingAccount);
    const isPayPalAccount = isFundingAccountPayPalDirect(fundingAccount);
    if (isPayPalAccount) {
        return (React.createElement("div", { className: "inline-flex gap-2 items-center" },
            React.createElement(PayPal, { "data-testid": "payment-method--paypal-icon" }),
            React.createElement("span", { className: "text-sm font-medium text-black", "data-fullstory": true }, fundingInfoPaypal?.paypalEmail)));
    }
    if (isBankAccount) {
        return (React.createElement("span", { className: "text-sm text-black font-semibold", "data-fullstory": true },
            fundingAccount.name,
            " ",
            React.createElement("span", { className: "text-grey-60 font-normal" }, fundingAccount.currencyCode)));
    }
    return (React.createElement("div", { className: "text-sm text-black font-medium", "data-fullstory": true },
        React.createElement("div", { className: "flex gap-4 items-center mb-3" },
            React.createElement(Email, { size: 16 }),
            React.createElement("span", { className: "font-semibold" }, getFundingInfoAddressDisplayName(fundingInfoAddress))),
        React.createElement("div", { className: "ml-[30px]" },
            React.createElement(AccountAddress, { ...fundingInfoAddress }))));
};
export default PaymentMethodHintBaseContent;
